import { Warning } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const fmtKg = (n) => Number(n || 0).toLocaleString("es-AR", { minimumFractionDigits: 0, maximumFractionDigits: 3 });

/**
 * Modal grande, centrado, con fondo bloqueado — se muestra cuando un pedido
 * de Tienda Nube intenta cargar más kg que los pedidos por el cliente.
 * Se dispara desde el catch de `marcarItemMostrador` cuando el backend
 * responde 409 con detail.code === "tn_kg_excedidos".
 */
export default function AlertaExcesoKgTNModal({ data, onClose }) {
  if (!data) return null;
  const { kg_pedidos, kg_intentados, excedente, producto, cliente, pedido_numero } = data;
  return (
    <div
      className="fixed inset-0 z-[200] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="alerta-exceso-kg-tn"
    >
      <div
        className="bg-white rounded-lg border-4 border-rose-600 max-w-2xl w-full shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-rose-600 px-6 py-4 flex items-center gap-3 text-white">
          <Warning size={36} weight="fill" />
          <div>
            <div className="font-heading font-black text-2xl uppercase tracking-wide">
              No se puede guardar
            </div>
            <div className="font-mono text-[13px] opacity-90">
              Estás cargando más kilos de los pedidos por el cliente
            </div>
          </div>
        </div>

        <div className="p-6 space-y-4">
          {pedido_numero && (
            <div className="text-[13px] font-mono text-neutral-500">
              Pedido <span className="font-bold text-neutral-800">#{pedido_numero}</span>
              {cliente ? <> · <span className="font-bold text-neutral-800">{cliente}</span></> : null}
            </div>
          )}
          <div className="border-2 border-rose-200 bg-rose-50 rounded-md p-4">
            <div className="text-[14px] uppercase font-mono font-bold text-rose-800 mb-2">
              {producto || "Producto"}
            </div>
            <table className="w-full text-[15px]">
              <tbody>
                <tr>
                  <td className="py-1.5 text-neutral-600">El cliente pidió</td>
                  <td className="py-1.5 text-right font-heading font-black text-emerald-700 text-2xl">
                    {fmtKg(kg_pedidos)} kg
                  </td>
                </tr>
                <tr>
                  <td className="py-1.5 text-neutral-600">Vos intentaste cargar</td>
                  <td className="py-1.5 text-right font-heading font-black text-neutral-800 text-2xl">
                    {fmtKg(kg_intentados)} kg
                  </td>
                </tr>
                <tr className="border-t-2 border-rose-300">
                  <td className="pt-3 pb-1.5 text-rose-700 font-bold">De más</td>
                  <td className="pt-3 pb-1.5 text-right font-heading font-black text-rose-700 text-3xl">
                    + {fmtKg(excedente)} kg
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="text-[13px] text-neutral-600 leading-relaxed">
            No mandamos más kilos de los que compró el cliente en Tienda Nube.
            Ajustá el peso a <span className="font-bold">{fmtKg(kg_pedidos)} kg</span> o menos
            para poder guardar.
          </div>
        </div>

        <div className="bg-neutral-50 border-t border-neutral-200 px-6 py-3 flex justify-end">
          <Button
            onClick={onClose}
            className="h-11 px-8 rounded-sm bg-rose-600 hover:bg-rose-700 text-white font-heading font-bold uppercase text-[14px]"
            data-testid="alerta-exceso-kg-cerrar"
          >
            Entendido, ajustar
          </Button>
        </div>
      </div>
    </div>
  );
}
